(function() { window.GUID_5d68fdee_89d4_4cba_a261_68478cd23fae = { getGuid: function() { return "5d68fdee-89d4-4cba-a261-68478cd23fae"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-stat-compare-against-others",
                        callback: (accordion, e) => {
                            var _a;
                            const isPremiumLocked = accordion.$Header.hasClass("is-premium-locked");
                            const $emptyStateElement = accordion.$Content.find(`#StatCompareAgainstOthersSectionViewModelNoData-${accordion.ContentId}`);
                            const $gameTypeNameInput = accordion.$Content.find(`#StatCompareAgainstOthersSectionViewModelGameTypeName-${accordion.ContentId}`);
                            const gameTypeName = (_a = $gameTypeNameInput.val()) !== null && _a !== void 0 ? _a : "";
                            if ($emptyStateElement.length) {
                                if (gameTypeName.trim() === "") {
                                    $emptyStateElement.text(JSRess.These2PlayersHaveNoCommonOpponent);
                                }
                                else {
                                    $emptyStateElement.html(CS.Helper.formatString(JSRess.These2PlayersHaveNoCommonOpponentIn, gameTypeName));
                                }
                                return;
                            }
                            const $dataInput = $(`#StatCompareAgainstOthersSectionViewModel-${accordion.ContentId}`);
                            if (!$dataInput.length) {
                                return;
                            }
                            const rawData = $dataInput.val();
                            if (rawData == null ||
                                (typeof rawData === "string" && rawData.trim() === "")) {
                                return;
                            }
                            const data = JSON.parse(rawData);
                            const playerColors = CS.Helper.DataVisualizationHelper.getColors(2);
                            const _opponentColors = [
                                CS.Helper.DataVisualizationHelper.MUI_PALETTE.lightGreen[500],
                                CS.Helper.DataVisualizationHelper.MUI_PALETTE.yellow[500],
                                CS.Helper.DataVisualizationHelper.MUI_PALETTE.deepPurple[300],
                                CS.Helper.DataVisualizationHelper.MUI_PALETTE.red[500],
                                CS.Helper.DataVisualizationHelper.MUI_PALETTE.teal[500],
                            ];
                            const opponentsCount = data.Entries.length;
                            const namePlayerA = data.PersonaPlayerA.PersonaName;
                            const namePlayerB = data.PersonaPlayerB.PersonaName;
                            const opponentsNames = data.Entries.map((entry) => entry.Opponent.PersonaName);
                            const $introductionContainer = accordion.$Container.find(`#StatCompareAgainstOthersSectionViewModelIntroduction-${accordion.ContentId}`);
                            if ($introductionContainer.length) {
                                let introductionHtml = "";
                                if (opponentsCount == 1) {
                                    introductionHtml = CS.Helper.formatString(JSRess.XAndYHaveBothPlayerdAgainstThisOpponentInZ, namePlayerA, namePlayerB, gameTypeName);
                                    introductionHtml += `${opponentsNames[0]}`;
                                }
                                else if (opponentsCount > 1) {
                                    introductionHtml = CS.Helper.formatString(JSRess.XAndYHaveBothPlayerdAgainstThisZOpponentInA, namePlayerA, namePlayerB, opponentsCount, gameTypeName);
                                    introductionHtml += `<ul>${opponentsNames
                                        .map((name) => `<li><strong><i>${name}</i></strong></li>`)
                                        .join("")}</ul>`;
                                }
                                if (introductionHtml != "") {
                                    $introductionContainer.html(introductionHtml);
                                    $introductionContainer.show();
                                }
                            }
                            const $gaugeChartCanvas = $(`#StatCompareAgainstOthersSectionViewModelGaugeChartCanvas-${accordion.ContentId}`);
                            if ($gaugeChartCanvas.length) {
                                const gaugeChartConfig = {
                                    type: "doughnut",
                                    data: {
                                        labels: [
                                            data.PersonaPlayerA.PersonaName,
                                            "",
                                            data.PersonaPlayerB.PersonaName,
                                        ],
                                        datasets: [
                                            {
                                                label: `${data.PersonaPlayerA.PersonaName},${data.PersonaPlayerB.PersonaName}`,
                                                data: [
                                                    data.WinsPercentAveragePlayerA.toFixed(2),
                                                    0.5,
                                                    data.WinsPercentAveragePlayerB.toFixed(2),
                                                ],
                                                backgroundColor: [playerColors[0], "white", playerColors[1]],
                                            },
                                        ],
                                    },
                                    options: {
                                        responsive: true,
                                        rotation: 270,
                                        circumference: 180,
                                        cutout: "70%",
                                        showLines: false,
                                        //borderWidth: 1,
                                        borderColor: "rgba(255,255,255,0.1)",
                                        layout: {
                                        // padding: 0,
                                        // autoPadding: false,
                                        },
                                        plugins: {
                                            legend: {
                                                display: false,
                                            },
                                            title: {
                                                display: false,
                                            },
                                            tooltip: {
                                                callbacks: {
                                                    label: function (context) {
                                                        const { label, parsed } = context;
                                                        if (label == null || parsed == null || label == "") {
                                                            return;
                                                        }
                                                        return ` ${label}: ${parsed}%`;
                                                    },
                                                    title: function (context) {
                                                        return "";
                                                    },
                                                },
                                            },
                                        },
                                        x: {
                                            display: false,
                                            stacked: false,
                                            grid: {
                                                color: "rgba(255, 255, 255, 0.25)",
                                                borderColor: "rgba(255, 255, 255, 0.1)",
                                            },
                                            ticks: {
                                                display: false,
                                                color: "rgba(255, 255, 255, 1)",
                                            },
                                        },
                                        y: {
                                            display: false,
                                            beginAtZero: false,
                                            max: null,
                                            ticks: {
                                                color: "rgba(255, 255, 255, 0.75)",
                                                callback: function (value, index, ticks) {
                                                    return value + "%";
                                                },
                                            },
                                            grid: {
                                                color: "rgba(255, 255, 255, 0.1)",
                                                borderColor: "rgba(255, 255, 255, 0.15)",
                                            },
                                        },
                                    },
                                };
                                const gaugeChartCanvas = $gaugeChartCanvas[0];
                                const gaugeChart = new Chart(gaugeChartCanvas, gaugeChartConfig);
                                gaugeChartCanvas.style.marginTop = "-20%";
                                gaugeChartCanvas.style.marginBottom = "-20%";
                            }
                            const $summaryExplanation = $(`#StatCompareAgainstOthersSectionViewModelGaugeChartCanvasExplanation-${accordion.ContentId}`);
                            if ($summaryExplanation.length && !isPremiumLocked) {
                                const averagePercentPlayerA = `<strong style="color: ${playerColors[0]};">${data.WinsPercentAveragePlayerA.toFixed(2)}%</strong>`;
                                const averagePercentPlayerB = `<strong style="color: ${playerColors[1]};">${data.WinsPercentAveragePlayerB.toFixed(2)}%</strong>`;
                                const averagePercentComparison = `${averagePercentPlayerA} VS ${averagePercentPlayerB}`;
                                const differentAverage = data.WinsPercentAveragePlayerA != data.WinsPercentAveragePlayerB;
                                let summaryExplanationHtml;
                                if (differentAverage) {
                                    let winnerHtml;
                                    if (data.WinsPercentAveragePlayerA > data.WinsPercentAveragePlayerB) {
                                        winnerHtml = `<i><strong style="color: ${playerColors[0]};">${data.PersonaPlayerA.PersonaName}</strong></i>`;
                                        // winnerHtml = `<i><strong style="color: white;">${data.PersonaPlayerA.PersonaName}</strong></i>`;
                                    }
                                    else {
                                        winnerHtml = `<i><strong style="color: ${playerColors[1]};">${data.PersonaPlayerB.PersonaName}</strong></i>`;
                                        // winnerHtml = `<i><strong style="color: white;">${data.PersonaPlayerB.PersonaName}</strong></i>`;
                                    }
                                    if (gameTypeName) {
                                        summaryExplanationHtml = CS.Helper.formatString(JSRess.XHasAHigherWinRateAgainstTheseYOpponentsInZ, winnerHtml, data.PersonasOpponents.length, gameTypeName);
                                    }
                                    else {
                                        summaryExplanationHtml = `<div class="winner-name">${CS.Helper.formatString(JSRess.XHasAHigherWinRateAgainstTheseYOpponents, winnerHtml, data.PersonasOpponents.length)} (${averagePercentComparison})</i>`;
                                    }
                                }
                                else {
                                    if (gameTypeName) {
                                        summaryExplanationHtml = `${CS.Helper.formatString(JSRess.OnAverageBothPlayersWinTheSamePecentageOfTimesAgainstTheseXOpponentsInY, data.PersonasOpponents.length, gameTypeName)} (${averagePercentComparison})`;
                                    }
                                    else {
                                        summaryExplanationHtml = `${CS.Helper.formatString(JSRess.OnAverageBothPlayersWinTheSamePecentageOfTimesAgainstTheseXOpponents, data.PersonasOpponents.length)} (${averagePercentComparison})`;
                                    }
                                }
                                $summaryExplanation.html(summaryExplanationHtml);
                            }
                            //StatCompareAgainstOthersSection.SetContentV1(
                            //  accordion,
                            //  playerColors,
                            //  data
                            //  );
                            StatCompareAgainstOthersSection.SetContentV2(accordion, playerColors, data);
                        },
                    });
                    let StatCompareAgainstOthersSection;
                    (function (StatCompareAgainstOthersSection) {
                        function SetContentV1(accordion, playerColors, data) {
                            const $allPersona1 = accordion.$Content.find(".compared-player-section-persona-1");
                            if ($allPersona1.length) {
                                //$allPersona1.css({
                                //    background: `${playerColors[0]}05`,
                                //    border: `1px solid ${playerColors[0]}50`,
                                //    "border-radius": "0.5em",
                                //});
                                $allPersona1.find(".pic-helper").css({
                                    border: `2px solid ${playerColors[0]}`,
                                });
                            }
                            const $allPersona2 = accordion.$Content.find(".compared-player-section-persona-2");
                            if ($allPersona2.length) {
                                //$allPersona2.css({
                                //    background: `${playerColors[1]}05`,
                                //    border: `1px solid ${playerColors[1]}50`,
                                //    "border-radius": "0.5em",
                                //});
                                $allPersona2.find(".pic-helper").css({
                                    border: `2px solid ${playerColors[1]}`,
                                });
                            }
                            const $versusIcons = accordion.$Content.find(".compared-player-section-vs");
                            if ($versusIcons.length) {
                                $versusIcons.each(function (index, versusIcon) {
                                    const $versusIcon = $(versusIcon);
                                    $versusIcon.css({
                                        position: "absolute",
                                        top: "50%",
                                        left: index == 0 || index % 2 == 0 ? "33%" : "67%",
                                        transform: "translate(-50%, -50%)",
                                    });
                                });
                            }
                            const $canvas = accordion.$Content.find("canvas.StatCompareAgainstOthersCanvas");
                            if (!$canvas.length)
                                return;
                            const labels = data.Entries.map((entry, index) => {
                                return `${entry.PersonaIdOpponent}`;
                            });
                            const datasets = [];
                            const datasetPlayerA = {
                                label: data.PersonaPlayerA.PersonaName,
                                backgroundColor: playerColors[0],
                                data: data.Entries.map((entry) => {
                                    return {
                                        x: entry.Datasets[0].WinsPercent,
                                        y: `${entry.PersonaIdOpponent}`,
                                        name: data.PersonaPlayerA.PersonaName,
                                        wins: entry.Datasets[0].Wins,
                                        losses: entry.Datasets[0].Losses,
                                    };
                                }),
                            };
                            const datasetPlayerB = {
                                label: data.PersonaPlayerB.PersonaName,
                                backgroundColor: playerColors[1],
                                data: data.Entries.map((entry) => {
                                    return {
                                        x: entry.Datasets[1].WinsPercent,
                                        y: `${entry.PersonaIdOpponent}`,
                                        name: data.PersonaPlayerB.PersonaName,
                                        wins: entry.Datasets[1].Wins,
                                        losses: entry.Datasets[1].Losses,
                                    };
                                }),
                            };
                            const datasetEmpty = {
                                label: "__EMPTY__",
                                backgroundColor: "transparent",
                                data: data.Entries.map((entry) => {
                                    return {
                                        x: 0,
                                        y: `${entry.PersonaIdOpponent}`,
                                        name: "__EMPTY__",
                                        wins: 0,
                                        losses: 0,
                                    };
                                }),
                            };
                            datasets.push(datasetEmpty);
                            datasets.push(datasetPlayerA);
                            datasets.push(datasetPlayerB);
                            const length = datasetPlayerA.data.length;
                            const aspectRatioToLengthMap = {
                                0: {
                                    mobile: 2,
                                    desktop: 2,
                                },
                                1: {
                                    mobile: 2,
                                    desktop: 2,
                                },
                                2: {
                                    mobile: 1.35,
                                    desktop: 1.5,
                                },
                                3: {
                                    mobile: 1,
                                    desktop: 1.25,
                                },
                                4: {
                                    mobile: 0.8,
                                    desktop: 1,
                                },
                                5: {
                                    mobile: 0.6,
                                    desktop: 0.6,
                                },
                            };
                            const aspectRatio = length <= 5 ? aspectRatioToLengthMap[length] : 2;
                            const chartV2 = new Chart($canvas[0], {
                                type: "bar",
                                data: {
                                    labels,
                                    datasets,
                                },
                                plugins: [
                                    ChartDataLabels,
                                    {
                                        beforeDatasetsDraw: function (chart, args, options) {
                                            const { ctx, chartArea: { top, bottom, left, right, width, height }, scales: { x, y }, } = chart;
                                            const numberOfTicks = y.ticks.length;
                                            const tickHeight = y.getPixelForTick(1) - y.getPixelForTick(0);
                                            for (let i = 0; i < numberOfTicks; i++) {
                                                const isEven = i % 2 === 0;
                                                const drawTop = top + i * tickHeight;
                                                ctx.fillStyle = isEven
                                                    ? `rgba(255,255,255,0.01)`
                                                    : "transparent";
                                                ctx.fillRect(left, drawTop, width, tickHeight);
                                            }
                                        },
                                    },
                                ],
                                options: {
                                    responsive: true,
                                    aspectRatio: CS.CommonData.Current.IsMobileDevice
                                        ? aspectRatio.mobile
                                        : aspectRatio.desktop,
                                    maintainAspectRatio: true,
                                    indexAxis: "y",
                                    elements: {
                                        bar: {
                                            borderWidth: 2,
                                        },
                                    },
                                    plugins: {
                                        legend: {
                                            //display: false,
                                            labels: {
                                                //padding: 20,
                                                color: "white",
                                                filter: function (legendItem, data) {
                                                    if (legendItem.text === "__EMPTY__") {
                                                        return false;
                                                    }
                                                    return true;
                                                },
                                            },
                                            title: {},
                                        },
                                        tooltip: {
                                            enabled: true,
                                            callbacks: {
                                                label: function (context) {
                                                    const { label, dataset, value, datasetIndex } = context;
                                                    const { data } = dataset;
                                                    const { x, name } = data[context.dataIndex];
                                                    const parsedX = parseFloat(x);
                                                    if (datasetIndex === 0) {
                                                        return "";
                                                    }
                                                    if (parsedX % 1 !== 0) {
                                                        return `${name} – ${parsedX.toFixed(2)}%`;
                                                    }
                                                    return `${name} – ${parsedX}%`;
                                                },
                                                title: function (context) {
                                                    const matchingDatapoint = data.Entries[context[0].dataIndex];
                                                    return `VS ${matchingDatapoint.Opponent.PersonaName}`;
                                                },
                                            },
                                            mode: "index",
                                            axis: "x",
                                        },
                                        datalabels: {
                                            labels: {
                                                winsPercent: {
                                                    color: function (context) {
                                                        const datapoint = context.dataset.data[context.dataIndex];
                                                        if (datapoint.x > 60) {
                                                            return "white";
                                                        }
                                                        const isPlayerA = context.datasetIndex === 1;
                                                        if (isPlayerA)
                                                            return playerColors[0];
                                                        return playerColors[1];
                                                    },
                                                    textShadowColor: "black",
                                                    textShadowBlur: 5,
                                                    formatter: function (value, context) {
                                                        const { x, wins, losses } = value;
                                                        const { datasetIndex } = context;
                                                        if (datasetIndex === 0) {
                                                            return "";
                                                        }
                                                        const parsedX = parseFloat(x);
                                                        const additionalInfoTxt = CS.Helper.formatString(JSRess.XGames, `(${wins}/${wins + losses}`) + ")";
                                                        if (parsedX % 1 !== 0) {
                                                            return `${parsedX.toFixed(2)}%  ${additionalInfoTxt}`;
                                                        }
                                                        return `${parsedX}%  ${additionalInfoTxt}`;
                                                    },
                                                    font: {
                                                        family: "Open Sans",
                                                        weight: 700,
                                                        size: 12,
                                                    },
                                                    clamp: true,
                                                    anchor: function (context) {
                                                        return "end";
                                                    },
                                                    align: function (context) {
                                                        const datapoint = context.dataset.data[context.dataIndex];
                                                        if (datapoint.x > 60) {
                                                            return "start";
                                                        }
                                                        return "end";
                                                    },
                                                },
                                            },
                                        },
                                    },
                                    scales: {
                                        x: {
                                            display: false,
                                            // stacked: true,
                                            grid: {
                                                color: "rgba(255, 255, 255, 0.05)",
                                            },
                                            ticks: {
                                                color: function (context) {
                                                    return "rgba(255,255,255,0.5)";
                                                },
                                                font: function (context) {
                                                    return { size: 12, style: "normal" };
                                                },
                                                callback: function (val, index) {
                                                    return `${val}%`;
                                                },
                                            },
                                            border: {
                                                color: "rgba(255, 255, 255, 0.25)",
                                            },
                                            min: 0,
                                            max: 100,
                                            // grace: 10,
                                        },
                                        y: {
                                            display: false,
                                            // stacked: true,
                                            beginAtZero: true,
                                            position: "left",
                                            grid: {
                                                color: "rgba(255, 255, 255, 0.1)",
                                            },
                                            border: {
                                                color: "rgba(255, 255, 255, 0.25)",
                                            },
                                            // min: 0,
                                            // max: DISPLAY_COUNT - 1,
                                            ticks: {
                                                color: function (context) {
                                                    return "white";
                                                },
                                                font: function (context) {
                                                    return { size: 16, style: "italic", weight: 600 };
                                                },
                                                callback: function (val, index) {
                                                    //const matchingEntry = data.Entries[index];
                                                    //return `VS ${matchingEntry.Opponent.PersonaName}`;
                                                    return "";
                                                },
                                            },
                                        },
                                    },
                                },
                            });
                            /* -------------------------------------------------------------------------- */
                            /*                            Set overlay elements                            */
                            /* -------------------------------------------------------------------------- */
                            // Idée: Ajouter un datapoint vide pour chaque dataset pour avoir un espace entre les barres et pouvoir afficher un titre du genre "VS Player"
                            CS.Lag(`StatCompareAgainstOthers-${accordion.ContentId}`, 150, () => {
                                if (!chartV2)
                                    return;
                                const chartDomRect = $canvas[0].getBoundingClientRect();
                                const { scales } = chartV2;
                                const yTicks = scales.y.ticks;
                                const $canvasContainer = $canvas.closest(".canvas-container");
                                chartV2.update();
                                let pixelForValue = 0;
                                let tickHeight = 0;
                                let imageWidth = 16;
                                const chartWidth = chartDomRect.width;
                                const areaLeft = chartV2.chartArea.left;
                                const ticksWidth = areaLeft - 8;
                                const $players = $canvasContainer.find(".StatCompareAgainstOthersPlayer");
                                data.Entries.forEach((entry, index) => {
                                    let $overlayElement = $canvasContainer.find(`.overlay-element-${index}`);
                                    if (!$overlayElement.length) {
                                        $canvasContainer.append(`<div class="overlay-element overlay-element-${index}" data-overlay-element-index="${index}"></div>`);
                                        $overlayElement = $canvasContainer.find(`.overlay-element-${index}`);
                                    }
                                    if (!$overlayElement.length)
                                        return;
                                    if (index == 0) {
                                        pixelForValue = scales.y.getPixelForValue(index);
                                        tickHeight = scales.y.getPixelForValue(index + 1) - pixelForValue;
                                        imageWidth = tickHeight - 8;
                                        if (imageWidth > 24) {
                                            imageWidth = 24;
                                        }
                                    }
                                    else {
                                        pixelForValue += tickHeight;
                                    }
                                    const linearGradientCssValue = `linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.05) 50%, rgba(255,255,255,0) 100%)`;
                                    $overlayElement.css({
                                        position: "absolute",
                                        top: `${pixelForValue}px`,
                                        left: `${0}px`,
                                        // width: `${chartWidth}px`,
                                        width: "100%",
                                        height: `${tickHeight}px`,
                                        // If index is odd, then the background is white
                                        background: index % 2 == 0 ? linearGradientCssValue : "transparent",
                                        transform: `translateY(-${tickHeight / 2}px)`,
                                        "z-index": "2",
                                        pointerEvents: "none",
                                        display: "flex",
                                        "justify-content": "flex-start",
                                        "align-items": "flex-start",
                                        padding: `0 ${imageWidth}px`,
                                        fontSize: "0.9em",
                                        fontStyle: "italic",
                                        border: "1px solid rgba(255,255,255,0.1)",
                                    });
                                    $overlayElement.addClass("hoverable");
                                    const label = `VS ${entry.Opponent.PersonaName}`;
                                    const $correspondingPlayer = $($players.get(index));
                                    $overlayElement.html(`
              <div 
                class="inner-content"
                style="
                display: flex;
                justify-content: flex-start;
                position: relative;
                align-items: center;">
                <div style="font-size: 0.8em; font-style: italic; font-weight: 600;">VS </div>
              </div>`);
                                    $overlayElement.find(".inner-content").append($correspondingPlayer);
                                    $correspondingPlayer.css({
                                        display: "flex",
                                    });
                                    $correspondingPlayer.find(".avatar").css({
                                        fontSize: `0.45em`,
                                    });
                                    $correspondingPlayer.find(".persona-name").css({
                                        fontSize: `0.9em`,
                                    });
                                    const $persona1Image = $correspondingPlayer.find(".StatCompareAgainstOthersPlayerPersona1Picture");
                                    const $persona2Image = $correspondingPlayer.find(".StatCompareAgainstOthersPlayerPersona2Picture");
                                    if ($persona1Image.length && $persona2Image.length) {
                                        const imageCss = {
                                            fontSize: `0.45em`,
                                            position: "absolute",
                                            left: "-8px",
                                            transform: `translateX(-100%)`,
                                            "z-index": "2",
                                        };
                                        const image1Top = tickHeight / 3 + imageWidth / 2 - 3;
                                        const image2Top = image1Top * 2 - imageWidth + 8;
                                        $persona1Image.css(Object.assign(Object.assign({}, imageCss), { top: `${image1Top}px` }));
                                        $persona2Image.css(Object.assign(Object.assign({}, imageCss), { top: `${image2Top}px` }));
                                    }
                                });
                            });
                        }
                        StatCompareAgainstOthersSection.SetContentV1 = SetContentV1;
                        function SetContentV2(accordion, playerColors, data) {
                            var _a;
                            try {
                                const containerElementId = `BarChartSectionContainerElement-${accordion.ContentId}`;
                                const legentContainerElementId = `BarChartSectionLegendContainerElement-${accordion.ContentId}`;
                                const $canvas = accordion.$Content.find("canvas.StatCompareAgainstOthersCanvas");
                                if (!$canvas.length)
                                    return;
                                $canvas.css({
                                    display: "none",
                                });
                                const $chartContainer = $canvas.closest(".canvas-container");
                                if (!$chartContainer.length)
                                    return;
                                // const $legendContainer = $(
                                //   `<svg id="${legentContainerElementId}" class="stat-container__legend"></svg>`
                                // );
                                // $chartContainer.before($legendContainer);
                                $chartContainer.addClass("stat-container__chart");
                                $chartContainer.attr("id", containerElementId);
                                accordion.CustomData = {
                                    scrollableBarChart: null,
                                };
                                if (!data || !((_a = data.Entries) === null || _a === void 0 ? void 0 : _a.length))
                                    return;
                                const datapoints = [];
                                const oneDecimalPlaceString = (value) => {
                                    let result = value.toFixed(1).toString().replace(",", ".");
                                    if (result.endsWith(".0")) {
                                        result = result.replace(".0", "");
                                    }
                                    return result;
                                };
                                data.Entries.forEach((entry, index) => {
                                    let valueRatioPercentageString = "";
                                    let stackedValueRatioPercentageString = "";
                                    const value = entry.Datasets[0].WinsPercent;
                                    const stackedValue = entry.Datasets[1].WinsPercent;
                                    if (value == 0 && stackedValue == 0)
                                        return;
                                    if (value == 0 || stackedValue == 0) {
                                        if (value == 0) {
                                            valueRatioPercentageString = "0";
                                            stackedValueRatioPercentageString = "100";
                                        }
                                        else {
                                            valueRatioPercentageString = "100";
                                            stackedValueRatioPercentageString = "0";
                                        }
                                    }
                                    else {
                                        const total = value + stackedValue;
                                        const valueRatio = value / total;
                                        const valueRatioPercentage = valueRatio * 100;
                                        valueRatioPercentageString = valueRatioPercentage.toFixed(0);
                                        stackedValueRatioPercentageString = (100 - Number(valueRatioPercentageString)).toFixed(0);
                                    }
                                    const datapoint = {
                                        Id: entry.PersonaIdPlayerA,
                                        Key: entry.PersonaIdOpponent,
                                        IsStacked: false,
                                        SortDirection: CS.Enumeration.SortDirection.Ascending,
                                        Name: entry.PlayerA.PersonaName,
                                        Avatar: entry.Opponent.PersonaImgUrl,
                                        Value: valueRatioPercentageString,
                                        DisplayValue: `${oneDecimalPlaceString(entry.Datasets[0].WinsPercent)}%`,
                                        StackedDisplayValue: `${oneDecimalPlaceString(entry.Datasets[1].WinsPercent)}%`,
                                        StackedValue: stackedValueRatioPercentageString,
                                        SortValue: "0",
                                        XAxisBottomLabel: `VS – ${entry.Opponent.PersonaName}`,
                                        XAxisTopLabel: `${entry.Datasets[0].Wins} / ${entry.Datasets[0].Wins + entry.Datasets[0].Losses}`,
                                        XAxisTopLabelStacked: `${entry.Datasets[1].Wins} / ${entry.Datasets[1].Wins + entry.Datasets[1].Losses}`,
                                        OpponentFallbackUrl: entry.OpponentFallbackUrl,
                                    };
                                    const stackedDatapoint = {
                                        Id: `${entry.PersonaIdPlayerA}-stacked`,
                                        Key: entry.PersonaIdOpponent,
                                        Value: stackedValueRatioPercentageString,
                                        StackedValue: "",
                                        IsStacked: true,
                                        SortDirection: CS.Enumeration.SortDirection.Ascending,
                                        SortValue: "0",
                                        Name: entry.PlayerA.PersonaName,
                                        Avatar: entry.Opponent.PersonaImgUrl,
                                        XAxisBottomLabel: `VS – ${entry.Opponent.PersonaName}`,
                                        XAxisTopLabel: `${oneDecimalPlaceString(entry.Datasets[1].WinsPercent)}%`,
                                        OpponentFallbackUrl: entry.OpponentFallbackUrl,
                                    };
                                    datapoints.push(datapoint);
                                    datapoints.push(stackedDatapoint);
                                });
                                // accordion.CustomData.scrollableBarChart.init();
                                const colors = CS.Helper.DataVisualizationHelper.getColors(2);
                                const nonStackedDatapoints = datapoints.filter((datapoint) => !datapoint.IsStacked);
                                if (!nonStackedDatapoints.length)
                                    return;
                                const $container = accordion.$Content.find(`.cs-compared-stats__body`);
                                nonStackedDatapoints.forEach((datapoint) => {
                                    const datapointId = `datapoint-${datapoint.Id}-${CS.Helper.generateRandomId()}`;
                                    const datapointBodyId = `${datapointId}-body`;
                                    const datapointHeaderId = `${datapointId}-header`;
                                    const html = `
            <div id="${datapointId}" class="datapoint stat-container">
                <div id="${datapointHeaderId}" class="datapoint-header">
                    <div class="opponent">
                        <div class="datapoint-avatar">
                            <img src="${datapoint.Avatar}" onerror="this.onerror=null;this.src='${datapoint.OpponentFallbackUrl}'" />
                        </div>
                        <div class="datapoint-name">
                            ${datapoint.XAxisBottomLabel}
                        </div>
                    </div>
                    <div class="values">
                        <div class="datapoint-value">
                            <div class="value__header">
                                ${datapoint.DisplayValue}
                            </div>
                            <div class="value__body">
                                ${datapoint.XAxisTopLabel}
                            </div>
                        </div>
                        <div class="datapoint-value">
                            <div class="value__header">
                                ${datapoint.StackedDisplayValue}
                            </div>
                            <div class="value__body">
                                ${datapoint.XAxisTopLabelStacked}
                            </div>
                        </div>
                    </div>
                </div>
                <div id="${datapointBodyId}" class="datapoint-body">
                </div>
            </div>
          `;
                                    $container.append(html);
                                    const extractedDatapoints = [
                                        {
                                            stackId: "0",
                                            seriesId: "A",
                                            value: Number(datapoint.Value),
                                            isStacked: false,
                                        },
                                        {
                                            stackId: "0",
                                            seriesId: "B",
                                            value: Number(datapoint.StackedValue),
                                            isStacked: true,
                                        },
                                    ];
                                    const comparedValueBarChart = new CS.Controls.ComparedValueBarChart({
                                        colors: colors,
                                        containerElementId: datapointBodyId,
                                        datapoints: extractedDatapoints,
                                    });
                                    comparedValueBarChart
                                        .init()
                                        .then(() => {
                                        console.log("ComparedValueBarChart.init() done");
                                    })
                                        .catch((error) => {
                                        console.log("ComparedValueBarChart.init() error", error);
                                    });
                                });
                            }
                            catch (error) {
                                console.error(error);
                            }
                        }
                        StatCompareAgainstOthersSection.SetContentV2 = SetContentV2;
                    })(StatCompareAgainstOthersSection = WallSections.StatCompareAgainstOthersSection || (WallSections.StatCompareAgainstOthersSection = {}));
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=stat-compare-against-others.js.map
